import {
   createRouter,
   createWebHashHistory,
   createWebHistory,
} from 'vue-router';
import authRouter from '@/modules/auth/router';
import clientRouter from '@/modules/client/router';
import polizaRouter from '@/modules/poliza/router';
import agroRouter from '@/modules/agro/router';
import caucionRouter from '@/modules/caucion/router';
import siniestrosRouter from '@/modules/siniestros/router';
import automotorRouter from '@/modules/automotor/router';
import creditosRouter from '@/modules/creditos/router';
import {
   isAuthenticatedGuard,
   isBsaUser,
   isReportesUser,
   isAutomotorUser,
} from '@/modules/auth/composables/auth-guard';
import artRouter from '@/modules/art/router';
import bsaRouter from '@/modules/bsa/router';
import reportesRouter from '@/modules/reportes/router';
import hipotecaRouter from '@/modules/hipoteca/router';
import rcRouter from '@/modules/responsabilidad-civil/router';

function checkAuth(to, from, next) {
   if (isAuthenticatedGuard()) {
      next({ name: 'menu' }); // Redirige a menu si está autenticado
   } else {
      next({ name: 'auth/login' }); // Redirige a login si no está autenticado
   }
}

const dev = window.location.host === 'localhost:8080';
const routes = [
   {
      path: '/',
      redirect: '/multicotizador',
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...authRouter,
   },
   {
      ...clientRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...polizaRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...caucionRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...agroRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...siniestrosRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...artRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...automotorRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard, isAutomotorUser],
   },
   {
      ...creditosRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...hipotecaRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...rcRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard],
   },
   {
      ...bsaRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard, isBsaUser],
   },
   {
      ...reportesRouter,
      meta: { requiresLayout: true },
      beforeEnter: [isAuthenticatedGuard, isReportesUser],
   },
   // REDIRECT Y NOT FOUND
   {
      path: '/:pathMatch(.*)*', // Ruta catch-all para rutas inexistentes
      redirect: { name: 'menu' }, // Redirige a menu
      beforeEnter: checkAuth,
   },
   {
      path: '/multicotizador/', // Ruta catch-all para rutas inexistentes
      redirect: { name: 'menu' }, // Redirige a menu
      beforeEnter: checkAuth,
   },
];

const router = createRouter({
   history: dev ? createWebHashHistory() : createWebHistory('/'),
   routes,
});

router.beforeEach((to, from, next) => {
   const excludedRoutes = ['recover-password', 'login'];
   if (excludedRoutes.includes(to.name)) {
      next();
      return;
   }

   // Si el usuario refresca el navegador o entra por URL directa
   if (from.name === undefined) {
      if (excludedRoutes.includes(to.name)) {
         next();
      } else {
         next({ name: 'login' });
      }
   } else {
      next(); // Permite continuar la navegación normalmente
   }
});

export default router;
